import { Link } from '@twistopayments/design-system/components/atoms/link'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

type Props = {
  text: React.ReactNode | string
  className?: string
  fontWeight?: 'regular' | 'medium'
  to?: string
}

export const ContentListLink = ({ text, to, fontWeight, className }: Props) => (
  <li className={className}>
    <Link to={to}>
      <Typography component="span" fontWeight={fontWeight} variant="b2">
        {text}
      </Typography>
    </Link>
  </li>
)
